import RootStore from "store/rootStore";
import { updatePointsPosition } from "./objectModifiedUtils";

const objectModifiedHandler = (obj: any, store: RootStore) => {
  if (
    store.labelerSegmentationStore.isReadOnly ||
    store.labelerSegmentationUiStore.imageLoadError
  ) {
    return;
  }

  const { action } = obj;
  switch (action) {
    case "drag":
      dragModifier(obj, store);
      break;
    case "modifyPolygon":
      polygontModifier(obj, store);
      break;
    case "scale":
    case "scaleX":
    case "scaleY":
    case "rotate":
      polygonResized(obj, store);
      break;
    default:
      break;
  }
};

const newPolygonsOnResizeMode = (store: RootStore, polyModif: any) => {
  const { polygons, setPolygons } = store.labelerSegmentationUiStore;

  const newPolygons = [...polygons].map((poly: any) => {
    if (poly.labelValue !== polyModif.get("name")) {
      return poly;
    }

    return {
      ...poly,
      points: updatePointsPosition(polyModif),
    };
  });
  setPolygons(newPolygons);
};

const dragModifier = (obj: any, store: RootStore) => {
  //   console.log("dragModifier --- ", obj.action, " -- ", obj.target);

  const {
    scaling,
    polygons,
    setPolygons,
    resizeMode,
  } = store.labelerSegmentationUiStore;

  const polyModif = obj.target;

  if (resizeMode) {
    newPolygonsOnResizeMode(store, polyModif);
  } else {
    const newPolygons = _isOut(polyModif, scaling)
      ? polygons
      : polygons.map((poly: any) => {
          if (poly.labelValue !== polyModif.get("name")) {
            return poly;
          }
          const points = Object.keys(polyModif.oCoords).map((k: any) => ({
            x: polyModif.oCoords[k].x,
            y: polyModif.oCoords[k].y,
          }));
          // return { ...poly, points: polyModif.points };
          return { ...poly, points };
        });
    setPolygons(newPolygons);
  }
};

const polygonResized = (obj: any, store: RootStore) => {
  const polyModif = obj.target;
  newPolygonsOnResizeMode(store, polyModif);
};

const polygontModifier = (obj: any, store: RootStore) => {
  // console.log('polygontModifier --- ', obj.action, " -- ", obj.target)

  const { scaling, polygons, setPolygons } = store.labelerSegmentationUiStore;

  const polyModif = obj.target;

  const newPolygons = _isOut(polyModif, scaling)
    ? polygons
    : polygons.map((poly: any) => {
        if (poly.labelValue !== polyModif.get("name")) {
          return poly;
        }
        // console.log('polyModif ', JSON.parse(JSON.stringify(polyModif.points))  )
        // console.log('poly ', JSON.parse(JSON.stringify(poly.points)) )
        return {
          ...poly,
          points: polyModif.points,
        };
      });
  setPolygons(newPolygons);
};

const _isOut = (polygon: any, scaling: any) => {
  return Object.keys(polygon.aCoords).find(
    (k: string) =>
      polygon.aCoords[k].x < 0 ||
      polygon.aCoords[k].x > scaling.newWidth ||
      polygon.aCoords[k].y < 0 ||
      polygon.aCoords[k].y > scaling.newHeight
  );
};

export default objectModifiedHandler;
